module.exports = __webpack_public_path__ + "static/assets/1c63c503911067b0a2e97a69631bbc40.png";